export enum CacheTypes {
  ALLERGIES = 'ALLERGIES',
  CACHE_METADATA = 'CACHE_METADATA',
  CLINIC_NOTES = 'CLINIC_NOTES',
  GOALS = 'GOALS',
  IMMUNIZATIONS = 'IMMUNIZATIONS',
  MEDICATIONS = 'MEDICATIONS',
  MESSAGING_INBOX = 'MESSAGING_INBOX',
  MESSAGING_OUTBOX = 'MESSAGING_OUTBOX',
  MY_DOCTORS = 'MY_DOCTORS',
  PREVENTIVE_CARE = 'PREVENTIVE_CARE',
  PROBLEMS = 'PROBLEMS',
  PROCEDURES = 'PROCEDURES',
  SOCIAL_HISTORY = 'SOCIAL_HISTORY',
  TEST_RESULTS = 'TEST_RESULTS',
  VISIT_SUMMARIES = 'VISIT_SUMMARIES',
  VITALS = 'VITALS'
}
